<template>
  <TemplateUnificado class="p-32" />
</template>

<script setup>
import TemplateUnificado from 'components/Template/TemplateUnificado.vue'
</script>

<style lang="scss" scoped></style>
